import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ThemeService } from './shared/utils/service/theme.service';
import { FontSizeService } from './shared/utils/service/font-size.service';
import { fadeInOut } from '../theme/animations';
import { DeviceService } from './shared/utils/service/device.service';
import {
  BLUE_LIGHT_FILTER_COOKIE_KEY,
  FONT_SIZE_COOKIE_KEY,
} from './shared/utils/constants';
import { filter } from 'rxjs';
import { trackGoogleAnalyticsPageView } from './analytics/ga';
import { ScaleService } from './shared/utils/service/scale.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  standalone: true,
  animations: [fadeInOut(0.1)],
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  themeService = inject(ThemeService);
  fontSizeService = inject(FontSizeService);
  scaleService = inject(ScaleService);
  private readonly router = inject(Router);
  blueLightFilter = this.themeService.blueLightFilter;

  isMobile = inject(DeviceService).isMobile;

  title = 'panel-inwestora';
  theme: string = 'theme-light';
  fontSize: number = 10;

  setBlueLightFilter() {
    const val = localStorage.getItem(BLUE_LIGHT_FILTER_COOKIE_KEY);
    if (!val) return;

    this.themeService.blueLightFilter.set(val === 'true');
  }

  setFontSize(fontSize: number) {
    const val = localStorage.getItem(FONT_SIZE_COOKIE_KEY);
    if (!val) return;

    this.fontSizeService.setFontSize(+fontSize);
  }

  ngOnInit() {
    this.scaleService.setScale();
    window.addEventListener('resize', this.scaleService.setScale);

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        trackGoogleAnalyticsPageView(
          e.urlAfterRedirects,
          document.title,
          window.location.href
        );
      });
  }
}
